import { get, total as _total, paginate as _paginate } from '@kit/utils/APIV1.js'

export const paginate = async(sortField, cast, direction, page, numberPerPage) => {
  return _paginate('minutes', sortField, cast, direction, page, numberPerPage)
}
export const total = async() => {
  return _total('minutes')
}
export const page = async() => {
  return get("minutes-page")
}
